import React, {useState} from "react";
import {DialogContent} from "@mui/material";
import {DialogContentContainer} from "../../../../../pages/user/balance/top-up-dialog/styled";
import {StandardDialogFooter} from "../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import {useAppSelector} from "../../../../../redux/store";
import BarekamInput from "../../../../../pages/components/input";
import {Message, MessageSections} from "../../../../../pages/components/message/message";
import allUsersService from "../../../../../services/all-users.service";
import {getMessage} from "../../../../../pages/shared/helper-functions";

const AdminGrantDiscountDialog = ({userId, onClose}: GrantDiscountDialogProps) => {
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    const [discount, setDiscount] = useState<number | null>(null);
    const [discountReason, setDiscountReason] = useState<string | null>(null);
    const [discountError, setDiscountError] = useState<string>();
    const [discountReasonError, setDiscountReasonError] = useState<string>();

    function submitPayment() {
        if (!discount) {
            setDiscountError('required');
        } else if (discount < 0 || discount > 100) {
            setDiscountError('discount_range_problem');
        } else if (!discountReason) {
            setDiscountReasonError('required');
        } else {
            allUsersService.editUser(userId, {discountPercent: discount, discountReason: discountReason})
                .then((response) => {
                    onClose(true);
                })
        }
    }

    return (
        <>
            <DialogContent>
                <DialogContentContainer>
                    <BarekamInput value={discount || ''}
                                  placeholder={getMessage('discount', MessageSections.MAIN, messageCache, languageId)}
                                  label={getMessage('discount', MessageSections.MAIN, messageCache, languageId)}
                                  type={"number"}
                                  customInputVariant={"standard"}
                                  width={'100%'}
                                  onChange={(event) => setDiscount(+event.target.value)}
                                  error={!!discountError}
                                  errorMessage={discountError && getMessage(discountError, MessageSections.MAIN, messageCache, languageId)}
                                  required/>

                    <BarekamInput value={discountReason || ''}
                                  placeholder={getMessage('discount_reason', MessageSections.MAIN, messageCache, languageId)}
                                  label={getMessage('discount_reason', MessageSections.MAIN, messageCache, languageId)}
                                  type={"string"}
                                  customInputVariant={"standard"}
                                  width={'100%'}
                                  onChange={(event) => setDiscountReason(event.target.value)}
                                  error={!!discountReasonError}
                                  errorMessage={discountReasonError && getMessage(discountReasonError, MessageSections.MAIN, messageCache, languageId)}
                                  required/>
                </DialogContentContainer>
            </DialogContent>
            <StandardDialogFooter
                saveLabel={<Message messageKey={'grant_discount'} sectionId={MessageSections.MAIN}/>}
                onSave={submitPayment}
                onCancel={() => onClose(false)}/>
        </>
    )
}

interface GrantDiscountDialogProps {
    userId: number,
    onClose: (withUpdate: boolean) => void,
}

export default AdminGrantDiscountDialog;
